import * as moment from 'moment';
import * as _ from 'lodash';
import { Component, FormEvent } from 'react';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, FollowUpDonorActionCreators, IApplicationState, IFollowUpDonorLookupDataResponse, IFollowUpDonorResponse } from '@nkr/store/index';
import { IBaseResponse, ICenterBase, IContact, IListItem } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Panel, Row } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import { IValidationDetails } from './validation';
import DetailsContent from './details-content';
import { Country } from '@nkr/enums/index';

interface IProps {
    centerId: number,
    donorId: number,
    isAdminLogin: boolean
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonor: (donorId: number) => Promise<IFollowUpDonorResponse>,
    getLookupData: (centerId: number) => Promise<IFollowUpDonorLookupDataResponse>
    update: (
        id: number,
        centerId: number,
        email: string,
        mrn: string,
        surveyInstanceSkip: number,
        phone: string,
        firstName: string, lastName: string,
        country: number, addressLine1: string, city: string, state: number, nonUsStateProvince: string, postalCode: string,
        gender: number,
        birthDate: string, donationDate: string,
        heightInches: number, weightLbs: number,
        registrationId: number, coordinatorContactId: number
    ) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    centerId: number,
    email: string,
    mrn: string,
    surveyInstanceSkip: number,
    phone: string,
    firstName: string,
    lastName: string,
    country: number,
    addressLine1: string,
    city: string,
    state: number,
    nonUsStateProvince: string,
    postalCode: string,
    birthDate: string,
    gender: number,
    donationDate: string,
    heightInches: number,
    heightSubFeet: number,
    heightSubInches: number,
    weightLbs: number,
    coordinatorContactId: number,
    validationDetails: IValidationDetails,
    dirty: boolean,
    errorMessage: string,
    messages: string[],
    saved: boolean,
    coordinatorList: IContact[],
    countryList: IListItem[],
    stateList: IListItem[],
    genderList: IListItem[],
    centerList: ICenterBase[],
    followUpSurveyInstanceList: IListItem[]
}

class FollowUpDonorAddEdit extends Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        email: '',
        mrn: '',
        surveyInstanceSkip: -1,
        phone: '',
        firstName: '',
        lastName: '',
        country: Country.UnitedStates,
        addressLine1: '',
        city: '',
        state: null,
        nonUsStateProvince: '',
        postalCode: '',
        birthDate: '',
        gender: null,
        donationDate: '',
        heightInches: null,
        heightSubFeet: null,
        heightSubInches: null,
        weightLbs: null,
        coordinatorContactId: 0,
        validationDetails: {
            email: true,
            phone: true,
            country: true,
            firstName: true,
            lastName: true,
            addressLine1: true,
            city: true,
            state: true,
            nonUsStateProvince: true,
            postalCode: true,
            gender: true,
            birthDate: true,
            donationDate: true,
            heightSubFeet: true,
            weightLbs: true
        },
        dirty: false,
        errorMessage: '',
        messages: [],
        saved: false,
        coordinatorList: [],
        countryList: [],
        stateList: [],
        genderList: [],
        centerList: [],
        followUpSurveyInstanceList: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting ready, one moment please...').then(() => {
            Promise.all([
                this.props.getDonor(this.props.donorId),
                this.props.getLookupData(this.props.centerId)
            ])
                .then(([donorResponse, lookupResponse]) => {
                    if (donorResponse.data.success && lookupResponse.data.success) {
                        let { centerId, mrn,
                            firstName, lastName, email,
                            surveyInstanceSkip,
                            phone,
                            country, addressLine1, city, state, nonUsStateProvince, postalCode,
                            birthDate, donationDate,
                            gender,
                            heightInches, heightSubFeet, heightSubInches,
                            weightLbs,
                            coordinatorContactId } = donorResponse.data.results;

                        let { coordinatorList, countryList, stateList, genderList, centerList, followUpSurveyInstanceList } = lookupResponse.data.results;

                        this.setState({
                            centerId,
                            mrn,
                            firstName, lastName, email,
                            surveyInstanceSkip,
                            phone,
                            country, addressLine1, city, state, nonUsStateProvince, postalCode,
                            birthDate, donationDate,
                            gender,
                            heightInches, heightSubFeet, heightSubInches,
                            weightLbs,
                            coordinatorContactId,
                            coordinatorList,
                            countryList,
                            stateList,
                            genderList,
                            centerList,
                            followUpSurveyInstanceList
                        });
                    }

                    this.props.hideLoading();
                });
        });
    }

    validate = () => {
        let { email,
            phone, country, firstName, lastName,
            addressLine1, city, state, nonUsStateProvince,
            postalCode, gender, birthDate, donationDate,
            heightSubFeet, weightLbs, coordinatorContactId,
            validationDetails } = this.state;


        let messages: string[] = [];


        validationDetails = {
            email: coordinatorContactId == 0 ? Utility.isValidEmail(email) : true,
            phone: phone != '',
            country: country >= 0,
            firstName: firstName != '',
            lastName: lastName != '',
            addressLine1: addressLine1 != '',
            city: city != '',
            state: state > 0,
            nonUsStateProvince: country == Country.Other ? nonUsStateProvince != '' : true,
            postalCode: postalCode != '',
            gender: gender > 0,
            birthDate: moment(birthDate, 'YYYY-MM-DD').isValid(),
            donationDate: moment(donationDate, 'YYYY-MM-DD').isValid(),
            heightSubFeet: heightSubFeet > 0,
            weightLbs: Utility.isNumber(weightLbs)
        };


        let parsedBirthDate = moment(birthDate, 'MM/DD/YYYY', true);
        let today = moment();
        let age = today.diff(birthDate, 'years');
        if (age < 18 || age > 100) {
            messages.push('Birth date must be between 18 and 100 years ago');
            validationDetails.birthDate = false;
        }

        return {
            validationDetails,
            messages
        };
    }

    getIsValid = () => {
        let { validationDetails } = this.state;

        return validationDetails.email && validationDetails.phone && validationDetails.country && validationDetails.firstName
            && validationDetails.lastName && validationDetails.addressLine1 && validationDetails.city && validationDetails.state
            && validationDetails.nonUsStateProvince && validationDetails.postalCode && validationDetails.gender
            && validationDetails.birthDate && validationDetails.donationDate && validationDetails.heightSubFeet
            && validationDetails.weightLbs;
    }

    handleCoordinatorContactChange = (coordinatorContactId: number) => {
        // this.setState({
        //     coordinatorContactId
        // });
    }

    handleCancel = () => {
        window.location.href = `/center/${this.props.centerId}/follow-up/donors`;
    }

    handleSave = () => {
        let {
            email,
            mrn,
            surveyInstanceSkip,
            phone, country, firstName, lastName,
            addressLine1, city, state, nonUsStateProvince,
            postalCode, gender, birthDate, donationDate,
            heightSubFeet, heightSubInches, weightLbs, coordinatorContactId
        } = this.state;

        let { validationDetails, messages } = this.validate();

        let isValid =
            validationDetails.email && validationDetails.phone && validationDetails.country && validationDetails.firstName
            && validationDetails.lastName && validationDetails.addressLine1 && validationDetails.city && validationDetails.state
            && validationDetails.nonUsStateProvince && validationDetails.postalCode && validationDetails.gender
            && validationDetails.birthDate && validationDetails.donationDate && validationDetails.heightSubFeet
            && validationDetails.weightLbs

        this.setState({
            validationDetails,
            messages,
            dirty: true
        }, () => {
            let heightInches = (heightSubFeet * 12) + heightSubInches;

            if (isValid) {
                this.props.showLoading('Saving donor follow-up, one moment please...').then(async () => {
                    let response = await this.props.update(
                        this.props.donorId,
                        this.props.centerId,
                        email,
                        mrn,
                        surveyInstanceSkip,
                        phone, firstName, lastName, country,
                        addressLine1, city, state, nonUsStateProvince,
                        postalCode, gender, birthDate, donationDate,
                        heightInches,
                        weightLbs, 0, coordinatorContactId);

                    this.setState({
                        saved: true
                    }, () => {
                        this.props.hideLoading();
                    });
                });
            } else {
                window.scroll(0, 0);
            }
        });
    }

    handleFieldChange = (field: string, value: any) => {
        let selectFields = ['surveyInstanceSkip', 'country', 'state', 'gender', 'heightSubFeet', 'heightSubInches', 'center', 'coordinatorContactId'];
        let isSelectField = selectFields.indexOf(field) >= 0;
        let state = _.cloneDeep(this.state);

        if (isSelectField) {
            state[field] = parseInt(value);
        } else {
            state[field] = value;
        }

        this.setState(state);
    }

    render = () => {
        const isValid = this.getIsValid();

        return (
            <div style={{ paddingBottom: 25 }}>
                <div className='text-center'>
                    <h1>Edit Donor for Follow-Up</h1>
                </div>
                {!isValid && (<>
                    <Row>
                        <Col xs={12} lg={8} lgOffset={2}>
                            <Alert bsStyle='danger'>
                                {this.state.errorMessage == '' ? (
                                    <span>The items in red are required to continue...</span>
                                ) : (
                                    <span>{this.state.errorMessage}</span>
                                )}
                                <Row>
                                    <Col>
                                        {this.state.messages.length > 0 && (
                                            <ul>
                                                {this.state.messages.map((message, index) => (
                                                    <li key={index}>{message}</li>
                                                ))}
                                            </ul>

                                        )}
                                    </Col>
                                </Row>
                            </Alert>
                        </Col>
                    </Row>
                </>)
                }
                {
                    this.state.saved && isValid && (
                        <Row>
                            <Col xs={12} lg={8} lgOffset={2}>
                                <Alert bsStyle='success' closeLabel='close'>
                                    Follow-up donor record saved successfully...
                                </Alert>
                            </Col>
                        </Row>
                    )
                }               

                <Row>
                    <Col xs={12} lg={8} lgOffset={2}>
                        <Panel>
                            <Panel.Body>
                                <DetailsContent
                                    mrn={this.state.mrn}
                                    email={this.state.email}
                                    surveyInstanceSkip={this.state.surveyInstanceSkip}
                                    phone={this.state.phone}
                                    firstName={this.state.firstName}
                                    lastName={this.state.lastName}
                                    country={this.state.country}
                                    addressLine1={this.state.addressLine1}
                                    city={this.state.city}
                                    state={this.state.state}
                                    nonUsStateProvince={this.state.nonUsStateProvince}
                                    postalCode={this.state.postalCode}
                                    birthDate={this.state.birthDate}
                                    gender={this.state.gender}
                                    donationDate={this.state.donationDate}
                                    heightSubFeet={this.state.heightSubFeet}
                                    heightSubInches={this.state.heightSubInches}
                                    weightLbs={this.state.weightLbs}
                                    coordinatorContactId={this.state.coordinatorContactId}
                                    dirty={this.state.dirty}
                                    validation={this.state.validationDetails}
                                    coordinatorList={this.state.coordinatorList}
                                    countryList={this.state.countryList}
                                    stateList={this.state.stateList}
                                    genderList={this.state.genderList}
                                    followUpSurveyInstanceList={this.state.followUpSurveyInstanceList}
                                    onFieldChange={this.handleFieldChange}
                                />
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={8} lgOffset={2}>
                        <Col xs={12} lg={6}>
                            <Button block bsStyle='primary' onClick={this.handleSave}>Save</Button>
                        </Col>

                        <Col xs={12} lg={6}>
                            <Button block onClick={this.handleCancel}>Cancel</Button>
                        </Col>
                    </Col>
                </Row>

            </div >
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getDonor: (donorId) => {
            return dispatch(FollowUpDonorActionCreators.getDonor(donorId));
        },
        getLookupData: (centerId) => {
            return dispatch(FollowUpDonorActionCreators.getLookupData(centerId));
        },
        update: (
            id,
            centerId,
            email,
            mrn,
            surveyInstanceSkip,
            phone,
            firstName, lastName,
            country, addressLine1, city, state, nonUsStateProvince, postalCode,
            gender,
            birthDate, donationDate,
            heightInches, weightLbs,
            registrationId, coordinatorContactId
        ) => {
            return dispatch(FollowUpDonorActionCreators.update(
                id,
                centerId,
                email,
                mrn,
                surveyInstanceSkip,
                phone,
                firstName, lastName,
                country, addressLine1, city, state, nonUsStateProvince, postalCode,
                gender,
                birthDate, donationDate,
                heightInches, weightLbs,
                registrationId, coordinatorContactId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FollowUpDonorAddEdit);